const productRight = document.getElementById('productRight');
const lockedOverlay = document.getElementById('lockedOverlay');
const uploadSection = document.getElementById('uploadSection');
const uploadBtnText = document.getElementById('uploadBtnText');
const uploadBtnSubtext = document.getElementById('uploadBtnSubtext');
const fileUploadOverlay = document.getElementById('fileUploadOverlay');
const overlayHistoryList = document.getElementById('overlayHistoryList');
const mainHistoryList = document.getElementById('historyList');

let hasUploadedPhoto = false;

function unlockOptionsPanel() {
    if (hasUploadedPhoto) return;
    hasUploadedPhoto = true;
    
    if (productRight) productRight.classList.remove('is-locked');
    if (lockedOverlay) lockedOverlay.classList.add('unlocked');
    if (uploadSection) uploadSection.classList.add('has-photo');
    if (uploadBtnText) uploadBtnText.textContent = changePhotoTitle;
    if (uploadBtnSubtext) uploadBtnSubtext.textContent = changePhotoSubtitle;
    document.getElementById('mainPreviewImage').style.display = "none";
    document.getElementById('glcanvas').style.display = "block";
}

// Listen to overlay upload button
if (fileUploadOverlay) {
fileUploadOverlay.addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (!file) return;
    
    unlockOptionsPanel();
    
    // Copy file to main upload input to trigger 3D model
    const mainUpload = document.getElementById('fileUpload');
    if (mainUpload) {
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    mainUpload.files = dataTransfer.files;
    mainUpload.dispatchEvent(new Event('change', { bubbles: true }));
    }
});
}


document.getElementById('fileUpload').addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (!file) return;

    // Unlock the options panel
    unlockOptionsPanel();

    const videoWrapper = document.getElementById('placeholderVideoWrapper');
    if (videoWrapper) {
        videoWrapper.classList.add('hidden');
    }

    const reader = new FileReader();
    reader.onload = function(event) {
        const mainImage = document.getElementById('mainPreviewImage');
        mainImage.style.display = 'block';
        mainImage.src = event.target.result;
    };
    reader.readAsDataURL(file);
});

// Swatch click handler
  document.addEventListener('click', function (e) { 
    // C6: הצ׳יפ מכיל span-ים, ולכן e.target עלול להיות ה-span.
    const button = e.target.closest('button[data-option]');
    if (!button) return;

    const optionName = button.dataset.option; 
    const value = button.dataset.value; 
    
    button.parentElement.querySelectorAll('button').forEach(btn => btn.classList.remove('selected')); 
    button.classList.add('selected'); 
    
    const input = document.querySelector(`input[name="options[${optionName}]"]`); 
    if (input) { 
      input.value = value; 
      input.dispatchEvent(new Event('change', { bubbles: true })); 
    }  
});

// Listen to overlay history clicks
if (overlayHistoryList) {
    overlayHistoryList.addEventListener('click', function(e) {
    const historyItem = e.target.closest(
      '.locked-overlay__history-item, .locked-overlay-he__history-item'
    );
    if (!historyItem) return;
    
    unlockOptionsPanel();
    
    // Find corresponding main history item and click it
    const img = historyItem.querySelector('img');
    if (img && mainHistoryList) {
    const mainItems = mainHistoryList.querySelectorAll('.history-item img');
    mainItems.forEach(mainImg => {
        if (mainImg.src === img.src) {
        mainImg.closest('.history-item').click();
        }
    });
    }
});
}

// Sync history from main to overlay
// function syncHistory() {
// if (!mainHistoryList || !overlayHistoryList) return;

// const mainItems = mainHistoryList.querySelectorAll('.history-item');

// if (mainItems.length === 0) {
//     overlayHistoryList.innerHTML = '<span class="locked-overlay__history-empty">No previous uploads</span>';
//     return;
// }

// let overlayHTML = '';
// mainItems.forEach(item => {
//     const img = item.querySelector('img');
//     if (img) {
//     overlayHTML += '<div class="locked-overlay__history-item"><img src="' + img.src + '" alt="Previous upload"></div>';
//     }
// });

// overlayHistoryList.innerHTML = overlayHTML || '<span class="locked-overlay__history-empty">No previous uploads</span>';
// }

// syncHistory();

// if (mainHistoryList) {
// const observer = new MutationObserver(syncHistory);
// observer.observe(mainHistoryList, { childList: true, subtree: true });
// }
function syncHistory() {
  if (!mainHistoryList || !overlayHistoryList) return;

  const mainItems = mainHistoryList.querySelectorAll('.history-item');

  if (mainItems.length === 0) {
    overlayHistoryList.innerHTML = `
      <span class="locked-overlay__history-empty">No previous uploads</span>
      <span class="locked-overlay-he__history-empty">אין העלאות קודמות</span>
    `;
    return;
  }

  let overlayHTML = '';
  mainItems.forEach(item => {
    const img = item.querySelector('img');
    if (img) {
      overlayHTML += `
        <div class="locked-overlay__history-item locked-overlay-he__history-item">
          <img src="${img.src}" alt="${(document.documentElement.lang || '').toLowerCase().startsWith('he') ? 'העלאה קודמת' : 'Previous upload'}">
        </div>`;
    }
  });

  overlayHistoryList.innerHTML = overlayHTML;
}

syncHistory();

if (mainHistoryList) {
  const observer = new MutationObserver(syncHistory);
  observer.observe(mainHistoryList, { childList: true, subtree: true });
}


// ═══════════════════════════════════════════════════════════════
// ENHANCED COLOR PICKER WITH PICKR - ORIGINAL CODE
// ═══════════════════════════════════════════════════════════════
  
let pickrInstance = null;
let currentColor = '#FFFFFF';

function updateColorDisplay(color) {
    currentColor = color;
    document.getElementById('colorPreviewBox').style.backgroundColor = color;
    document.getElementById('colorHexDisplay').textContent = color.toUpperCase();
    document.getElementById('customColorValue').value = color;
    
    document.querySelectorAll('.quick-color').forEach(el => {
    el.classList.toggle('selected', el.dataset.color.toUpperCase() === color.toUpperCase());
    });
    
    if (typeof setSelectedColor === 'function') {
    setSelectedColor(color);
    }
    if (typeof refreshCurrentWithColor === 'function') {
    refreshCurrentWithColor();
    }
}

function initPickr() {
    if (typeof Pickr === 'undefined') {
    setTimeout(initPickr, 100);
    return;
    }

    const pickrElement = document.getElementById('colorPickr');
    if (!pickrElement || pickrInstance) return;

    pickrInstance = Pickr.create({
    el: '#colorPickr',
    theme: 'nano',
    default: '#FFFFFF',
    position: 'bottom-start',
    swatches: null,
    components: {
        preview: true,
        opacity: false,
        hue: true,
        interaction: {
        hex: true,
        input: true,
        save: true
        }
    },
    i18n: {
        'btn:save': '✓ Select'
    }
    });

    pickrInstance.on('change', (color) => {
    const hexColor = color.toHEXA().toString().substring(0, 7);
    updateColorDisplay(hexColor);
    });

    pickrInstance.on('save', () => {
    pickrInstance.hide();
    });

    document.getElementById('pickrTrigger').addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    pickrInstance.show();
    });

    document.querySelectorAll('.quick-color').forEach(el => {
    el.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const color = this.dataset.color;
        updateColorDisplay(color);
        if (pickrInstance) {
        pickrInstance.setColor(color);
        }
    });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickr);
} else {
    initPickr();
}

// ═══════════════════════════════════════════════════════════════
// ENHANCED COLOR PICKER WITH PICKR - ORIGINAL CODE
// ═══════════════════════════════════════════════════════════════